module.exports = __webpack_public_path__ + "img/footer-image2.e7c69d68.png";